import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { CONTRATO_VARIABLES_AYUDA } from '../../../services/contratoVentaService';

interface ContratoVariablesChipsProps {
  onInsert: (variable: string) => void;
  disabled?: boolean;
}

const ContratoVariablesChips: React.FC<ContratoVariablesChipsProps> = ({ onInsert, disabled }) => (
  <Box sx={{ mb: 1 }}>
    <Typography variant="caption" color="text.secondary" component="div">
      Variables disponibles (clic para insertar en el cursor):{' '}
      {CONTRATO_VARIABLES_AYUDA.map((v) => (
        <Chip
          key={v}
          size="small"
          label={v}
          clickable={!disabled}
          onMouseDown={disabled ? undefined : (e) => e.preventDefault()}
          onClick={disabled ? undefined : () => onInsert(v)}
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      ))}
    </Typography>
  </Box>
);

export default ContratoVariablesChips;
